import React from 'react';

export const ProgressBar = ({ progress, className = '' }) => {
  const getProgressColor = () => {
    if (progress < 30) return 'bg-red-500';
    if (progress < 70) return 'bg-yellow-500';
    return 'bg-green-500';
  };

  return (
    <div className={`progress-container ${className}`} data-testid="progress-bar-container">
      <div className="progress-bar">
        <div 
          className={`progress-fill ${getProgressColor()}`}
          style={{ width: `${progress}%` }}
          data-testid="progress-fill"
        />
      </div>
      <span className="progress-text" data-testid="progress-text">{progress}%</span>
    </div>
  );
};
